
import React from 'react';
import {Navbar,Nav,Form,Button} from 'react-bootstrap';
export default class Header extends React.Component{

render(){

  var t=[false,false,false];
if(window.location.href.includes("tarification")){
  t[1]=true;

}else{
  if(window.location.href.includes("models")){
    t[2]=true;
  
  }else{
    t[0]=true;

  }
} 


    return(
        <Navbar bg="dark" variant="dark" style={{fontSize:'18px'}}>
      <Navbar.Brand href="/" style={{fontSize:'18px',textAlign:'center'}}>Portfolio Maker</Navbar.Brand>
      <Nav className="mr-auto">
        <Nav.Link href="/" active={t[0]}>Home</Nav.Link>
        <Nav.Link href="/tarification" active={t[1]}>Tarification</Nav.Link>
        <Nav.Link href="/models" active={t[2]}>Modeles</Nav.Link>
      </Nav>
      
      <Form inline style={{fontSize:'18px'}}>
      
      <Navbar.Collapse className="justify-content-end" >
    <Navbar.Text style={{display:"none"}} id="signed">
      Signed in as: <a href="/profile"></a>
    </Navbar.Text>
  </Navbar.Collapse>
        <Button variant="outline-info" style={{fontSize:'18px'}}>Essaye gratuit</Button>	&nbsp;&nbsp;
        <Button variant="info" href="/signup" style={{fontSize:'18px'}}>Se connecter</Button>
      </Form>
    </Navbar>
    )
}

}